import Vue, { PropType, VNode } from 'vue';

import { SldsAlertVariant } from './Alert..types';

export default Vue.extend({
  name: 'SldsAlert',
  props: {
    variant: {
      type: String as PropType<SldsAlertVariant>,
      default: SldsAlertVariant.Info,
      validator: (val) => Object.values(SldsAlertVariant).includes(val),
    },
  },
  render(h): VNode {
    return h(
      'div',
      {
        attrs: { role: 'alert' },
        staticClass: 'slds-notify slds-notify_alert',
        class: {
          [`slds-alert_${this.variant}`]:
            this.variant !== SldsAlertVariant.Info,
        },
      },
      [
        h('span', { staticClass: 'slds-assistive-text' }, this.variant),
        h('h2', undefined, this.$slots.default),
      ]
    );
  },
});
